import React from 'react'
import Image from 'next/image'
import { searchProvidersPromoHeadshots } from '@/components/Refresh/SearchResults/searchProvidersPromoHeadshots'
import classes from './ProvidersLeading.module.css'

/** Circular provider headshot stack for in-person / doctor featured cards. */
export default function ProvidersLeading() {
    return (
        <div className={classes.stack} aria-hidden>
            {searchProvidersPromoHeadshots.map((headshot) => (
                <span key={headshot.src} className={classes.circle}>
                    <Image
                        src={headshot}
                        alt=""
                        fill
                        sizes="48px"
                        className={classes.image}
                        loading="lazy"
                        decoding="async"
                    />
                </span>
            ))}
        </div>
    )
}
